export const DATE_FORMAT = 'YYYY-MM-DD';
export const STOREFRONT_LANG_KEY = 'monkeybook-storefront-language';
